import React from 'react'
import PropTypes from 'prop-types'
import { Button as ButtonMaterialUI, CircularProgress } from '@material-ui/core';

const Button = props => {
  const { loading, ...otherProps } = props;
  if (loading) {
    return (
      <ButtonMaterialUI startIcon={<CircularProgress size={18} />} {...otherProps} />
    )
  }
  return (
    <ButtonMaterialUI {...otherProps} />
  )
}

Button.propTypes = {
  loading: PropTypes.bool,
}

Button.defaultValue = {
  loading: false,
}

export default Button
